import type { SearchFieldOption } from 'core/components/server-side-pagination/ServerSideSearch'
import type { SortFieldOption } from 'core/components/server-side-pagination/ServerSideSort'

export const VOLUME_STATES_TOOLTIPS = [
  { name: 'Creating', description: 'The volume is being created' },
  {
    name: 'Reserved',
    description:
      'The volume is currently being held for attachment to a VM and is temporarily unavailable for other operations. A volume enters this state temporarily when being prepared for attachment to a VM.',
  },
  { name: 'Attaching', description: 'The volume is being attached to an VM.' },
  { name: 'Detaching', description: 'The volume is being detached from a VM.' },
  { name: 'In-Use', description: 'The volume is attached to a VM.' },
  { name: 'Maintenance', description: 'The volume is locked and being migrated.' },
  { name: 'Deleting', description: 'The volume is being deleted.' },
  {
    name: 'Awaiting Transfer',
    description:
      "The volume is awaiting transfer to another tenant. A volume enters this state when it's being transferred from one tenant to another.",
  },
  { name: 'Error', description: 'A volume creation error occurred.' },
  { name: 'Error Deleting', description: 'A volume deletion error occurred.' },
  { name: 'Retyping', description: 'The volume is changing type to another volume type.' },
  { name: 'Extending', description: 'The volume is being extended.' },
  {
    name: 'Error Extending',
    description: 'An error occurred while attempting to extend the volume.',
  },
  { name: 'Downloading', description: 'The volume is downloading an image.' },
  { name: 'Uploading', description: 'The volume is being uploaded to an image.' },
  { name: 'Backing Up', description: 'The volume is being backed up.' },
  { name: 'Restoring Backup', description: 'A backup is being restored to the volume.' },
  { name: 'Error Backing Up', description: 'A backup error occurred.' },
  { name: 'Error Restoring', description: 'A backup restoration error occurred.' },
]

// Search field options for volumes
export const VOLUMES_SEARCH_FIELDS: SearchFieldOption[] = [
  { value: 'name', label: 'Name' },
  { value: 'id', label: 'UUID' },
  { value: 'user_id', label: 'User ID' },
  { value: 'backend', label: 'Volume Backend' },
  { value: 'volume_type', label: 'Volume Type' },
]

// Sort field options for volumes
export const VOLUMES_SORT_OPTIONS: SortFieldOption[] = [
  { value: 'created_at', label: 'Created' },
  { value: 'name', label: 'Name' },
  { value: 'size', label: 'Size' },
]

// Grid column key → Cinder API sort key
export const VOLUME_COLUMN_TO_SORT_KEY: Record<string, string> = {
  name: 'name',
  size: 'size',
  created_at: 'created_at',
}

// Cinder API sort key → Grid column key (reverse of above)
export const VOLUME_SORT_KEY_TO_COLUMN: Record<string, string> = Object.fromEntries(
  Object.entries(VOLUME_COLUMN_TO_SORT_KEY).map(([col, api]) => [api, col]),
)

export const HelperTooltipMessages = {
  ManagementHost:
    'The host managing this volume’s backend. Handles scheduling, API operations, and coordination tasks',
  HypervisorHost: 'The compute host where the volume is attached and actively used by a VM',
}

export const VOLUME_ERROR_STATES = [
  'error',
  'error_deleting',
  'error_backing-up',
  'error_restoring',
  'error_extending',
] as const

export const VOLUME_ERROR_RESOURCE_TYPES = ['VOLUME', 'VOLUME_SNAPSHOT', 'VOLUME_BACKUP']
